import { validateZhihao, type Zhihao } from "@briefmarken_katalog/types";
import type { TranslationKey } from "$lib/i18n";

/**
 * The Zhihao is optional everywhere, so validation only kicks in once one is set.
 * Returns null when there is nothing to complain about, which lets callers write
 * `return validateZhihaoField(this.zhihao) ?? <next check>`.
 */
export function validateZhihaoField(zhihao: Zhihao | undefined): [boolean, TranslationKey | ''] | null {
  if (!zhihao) return null;
  const [ok, key] = validateZhihao(zhihao);
  return ok ? null : [false, key as TranslationKey];
}
